import React from 'react';
import { useNavigate } from 'react-router';
import EmptyTable from 'Components/EmptyTable';
import { UnauthorizedRoutePaths } from 'Interfaces/RoutePaths';

import TeamIcon from 'Assets/images/icons/team-empty-icon.svg';

const ForbiddenAccessTable = () => {
  const navigate = useNavigate();

  return (
    <EmptyTable
      buttonText="Back to main page"
      icon={TeamIcon}
      iconClassName="empty-table__icon--team"
      onClick={() => {
        navigate(UnauthorizedRoutePaths.BASE_PATH);
      }}
      headerText="Oops! You don’t have access."
      description="Your account is part of a Signaturely team account. Please contact with your team administrator to perform updates on these settings."
    />
  );
};

export default ForbiddenAccessTable;
